<template>
  <v-app>
      <v-main>
          <component :is="layout">
              <router-view />
          </component>
      </v-main>
  </v-app>
</template>

<script>
// @ is an alias to /src
import Default from "@/layouts/DefaultLayout.vue";
import ConnexionLayout from "@/layouts/ConnexionLayout.vue";

const default_layout = "Default";

export default {
  name: 'App',

  components: {
      Default,
      ConnexionLayout
  },
  computed: {
      layout() {
          return (this.$route.meta.layout || default_layout);
      },
  },
  data: () => ({
      //
  }),
};
</script>
